<template>
	<div class="header">
		<div class="wrapper">
			<router-link to="/brightmain">
				<span class="word">{{$t("charpter-one.cp-one-top.title[0]")}}</span>
			</router-link>
			<router-link to="/aboutUs">
				<span class="word">{{$t("charpter-one.cp-one-top.title[1]")}}</span>
			</router-link>
			<!-- <router-link to="/help">
				<span class="word">{{$t("charpter-one.cp-one-top.title[2]")}}</span>
			</router-link> -->
			<router-link to="/linkUs">
				<span class="word">{{$t("charpter-one.cp-one-top.title[3]")}}</span>
			</router-link>
				<span class="word lang" @click="changeLangEvent">{{$t("charpter-one.cp-one-top.title[4]")}}</span>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
import { setup } from "../../main.js"

export default {
	mounted() {
	},
	methods: {
		changeLangEvent() {
			if(this.$i18n.locale === 'zh') {
				 setup('en')
			} else {
				 setup('zh')
			}
			// setup(lang)
			// this.$emit('changeToEnglish')
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.header
		position: fixed
		top: 0
		left: 0
		width: 100%
		background: $color-background
		height: 32px
		box-shadow: 0 0.5px 1px $color-text-m
		// border-bottom: 1px solid #eee
		.wrapper
			line-height: 30px
			float: right
			.word
				line-height: 15px
				display: inline-block
				border-right: 1px dashed $color-text-m
				padding: 0 20px
				color: $color-text-m
				font-size: $font-web-small-s
				&:hover
					color: $color-theme
					cursor: pointer
			.lang
				border: none
				margin-right: 10px
				
</style>



// WEBPACK FOOTER //
// src/components/m-header/m-header.vue